export const QA_NAME_OVERVIEW_LOAD_RETRY = 'rentalPortalOverviewLoadRetry'
